var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-text-muted text-xs overflow-hidden"},[_c('transition',{attrs:{"name":"slide"}},[(_vm.shown)?_c('div',{staticClass:"transition duration-500"},[_vm._v(_vm._s(_vm.$t('saved')))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }